"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UseWorkerProcessor", {
    enumerable: true,
    get: function() {
        return UseWorkerProcessor;
    }
});
const _common = require("@nestjs/common");
const _tablesservice = require("~/services/tables.service");
const _attachmentsservice = require("~/services/attachments.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let UseWorkerProcessor = class UseWorkerProcessor {
    async job(job) {
        const { service, method, args } = job.data;
        return this.serviceMap[service][method](...args);
    }
    constructor(attachmentsService, tablesService){
        this.attachmentsService = attachmentsService;
        this.tablesService = tablesService;
        this.logger = new _common.Logger(UseWorkerProcessor.name);
        this.serviceMap = {
            [_attachmentsservice.AttachmentsService.name]: this.attachmentsService,
            [_tablesservice.TablesService.name]: this.tablesService
        };
    }
};
UseWorkerProcessor = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _attachmentsservice.AttachmentsService === "undefined" ? Object : _attachmentsservice.AttachmentsService,
        typeof _tablesservice.TablesService === "undefined" ? Object : _tablesservice.TablesService
    ])
], UseWorkerProcessor);
